import Loader from "components/Loader";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "utils/ToastNotistack";
// Backend handles getBooks

const ReckonCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get("code");

  useEffect(() => {
    const run = async () => {
      if (!code) {
        toast("Authorization code is missing.", { variant: "error" });
        if (window.opener) window.close();
        else navigate("/", { replace: true });
        return;
      }

      if (window.opener) {
        window.opener.postMessage(`RECKONCODE=${code}`, window.location.origin);
        window.close();
      } else {
        navigate("/", { replace: true });
      }
    };

    run();
  }, [code, navigate]);

  return <Loader />;
};

export default ReckonCallback;
